'use strict';

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

var self = module.exports = {
  all: {},
  cache: {},
  findByIso2: function findByIso2(code) {
    return x(self.all[code]);
  },
  findByIso3: function findByIso3(code) {
    return find('iso3', code);
  },
  findByName: function findByName(name) {
    return find('name', name);
  },
  findByCapital: function findByCapital(name) {
    return find('capital', name);
  },
  findByCurrency: function findByCurrency(code) {
    return find('currency', code);
  },
  findByProvince: function findByProvince(name) {
    if (!self.cache.province) self.cache.province = {};
    if (self.cache.province[name]) return self.cache.province[name].map(function (o) {
      return x(o);
    });
    return self.cache.province[name] = Object.keys(self.all).map(function (k) {
      return self.all[k];
    }).filter(function (o) {
      return o.provinces;
    }).filter(function (o) {
      return o.provinces.filter(function (o) {
        return o.name == name || (o.alias || []).indexOf(name) > -1;
      }).length > 0;
    }).map(function (o) {
      return x(o);
    }).unpack(undefined);
  },
  findByPhoneNbr: function findByPhoneNbr(nbr) {
    // make sure the phone number is clean
    nbr = nbr.replace(/\D/g, ''); // now match prefixes against the phone number

    return phones.filter(function (o) {
      return o.nbr && nbr.startsWith(o.nbr);
    }).map(function (o) {
      return x(self.all[o.code]);
    }).unpack(undefined);
  },
  ls: function ls(field) {
    var _this = this;

    return Object.keys(this.all).map(function (k) {
      return _this.all[k][field];
    });
  },
  continents: function continents() {
    return this.ls('continent').unique();
  },
  names: function names() {
    return this.ls('name');
  },
  capitals: function capitals() {
    return this.ls('capital');
  }
}; // transform to the old format for backward-compatibility

function x(o) {
  if (!o) return;
  if (Array.isArray(o)) return o.map(x(o));
  var ret = Object.assign({}, o);
  ret.currency = {
    code: ret.currency,
    symbol: ret.currency_symbol,
    decimal: ret.currency_decimal
  };
  ret.code = {
    iso2: ret.iso2,
    iso3: ret.iso3
  };

  var _iterator = _createForOfIteratorHelper('iso2|iso3|currency_symbol|currency_decimal'.split('|')),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var k = _step.value;
      delete ret[k];
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return ret;
}

function find(prop, val) {
  if (!(prop in self.cache)) self.cache[prop] = {};
  if (self.cache[prop][val]) return self.cache[prop][val];
  return self.cache[prop][val] = Object.keys(self.all).filter(function (k) {
    return self.all[k][prop] == val;
  }).map(function (k) {
    return x(self.all[k]);
  }).unpack(undefined);
}

var continents = require('./data/continents.json');

var continent = require('./data/continent.json');

var iso_alpha_3 = require('./data/iso_alpha_3.json');

var capital = require('./data/capital.json');

var currency = require('./data/currency.json');

var currency_info = require('./data/currency_info.json');

var names = require('./data/names.json');

var phone = require('./data/phone.json');

var regions = require('./data/regions.json');

var provinces = require('./data/provinces.json'); // compact it into a single object


Object.keys(iso_alpha_3).forEach(function (k) {
  self.all[k] = {
    iso2: k,
    iso3: iso_alpha_3[k],
    name: names[k],
    continent: continents[continent[k]],
    region: regions[k],
    capital: capital[k],
    currency: currency[k],
    currency_symbol: currency_info[currency[k]].symbol,
    currency_decimal: currency_info[currency[k]].decimal,
    dialing_code: phone[k],
    provinces: provinces[k]
  };
}); // release memory (except for phone)

continents = continent = iso_alpha_3 = capital = currency = currency_info = names = regions = provinces = null; // phone gets turned into a sorted array

var phones = Object.keys(phone).map(function (k) {
  return {
    code: k,
    nbr: phone[k].replace(/\D/g, '')
  };
}); // we need to match the phone number against the longest
// prefix we can find.  that avoids matching against 1 (US)
// when we should be matching against 1246 (Barbados)

phones.sort(function (a, b) {
  return a.nbr.length < b.nbr.length ? 1 : -1;
});
phone = null;

Array.prototype.unpack = function () {
  var l = this.length;
  return l == 1 ? this[0] : l == 0 && arguments.length > 0 ? undefined : this;
};

Array.prototype.unique = function () {
  var _this2 = this;

  return this.filter(function (e, pos) {
    return _this2.indexOf(e) == pos;
  });
};